<res-patent-documentation-link></res-patent-documentation-link>
<div>
	<!-- delete confirmation dialog from common package -->
	<res-confirmation-dialog></res-confirmation-dialog>

	<!-- res information dialog - record can not be deleted due to connections in other objects -->
	<res-information-dialog></res-information-dialog>

	<his-search-result #SearchResultComponent [showTitle]="true" [showNewSearchButton]="true"
		jobStarterKey="fs.res.search-patent-reports" defaultActionRoute="/patent/view/:id" idColumn="Patent.id"
		defaultColumn="Patent.title">

        <ng-container *ngIf="showBackButton" customResultButtons>
			<button (click)="navigationService.navigateToLastBackUrl()"> {{'common.back' | hisUi }} </button>
		</ng-container>
		
		<ng-template #rowAction let-row="row">
			<!-- search result config for create priority claim patent -->
			<div *ngIf="priorityPatentSearchResult">
				<ng-container *ngIf="auth.hasAny('RIGHT_FS_RES_PATENT_CREATE_PATENT')">
					<a routerLink="/patent/create/{{row.get('Patent.id')}}" hisImage="CONTEXT_ADD"
						title="{{'fs.res.patent.priorityClaim.createOf'|hisUi:row.get('Patent.title')}}"></a>
				</ng-container>
			</div>

			<!-- search result config for edit/search patents -->
			<div *ngIf="!priorityPatentSearchResult">

				<a (click)="onBeforeNavigate()" routerLink="/patent/view/{{row.get('Patent.id')}}" [queryParams]="{showBackButton: showBackButton}"  hisImage="magnifier_detail"
					title="{{'common.showOf'|hisUi:row.get('Patent.title')}}"></a>

				<!-- edit "button": disabling needs some trickery because links do not support the disabled attribute -->
				<ng-container *ngIf="auth.hasAny('RIGHT_FS_RES_PATENT_EDIT_PATENT')">
					<a *ngIf="row.get('canEdit')" (click)="onBeforeNavigate()" routerLink="/patent/edit/{{row.get('Patent.id')}}" [queryParams]="{showSearchButton: true, showBackButton: showBackButton}" hisImage="pencil"
						title="{{'common.editOf'|hisUi:row.get('Patent.title')}}"></a>
					<img *ngIf="!row.get('canEdit')" hisImage="pencil_i" class="inlineicon"
						title="{{'common.editOf'|hisUi:row.get('Patent.title')}}">
				</ng-container>

				<!-- delete button -->
				<ng-container *ngIf="auth.hasAny('RIGHT_FS_RES_PATENT_DELETE_PATENT')">
					<button (click)="deleteRow(row)" hisImage="delete" class="icon"  [disabled]="!row.get('canDelete')"
						title="{{'common.deleteOf'|hisUi:row.get('Patent.title')}}"></button>
				</ng-container>

				<ng-container *ngIf="auth.hasAny('RIGHT_FS_RES_PATENT_CREATE_PATENT')">
					<a *ngIf="!row.get('Patent.priorityPatent.id')"
						routerLink="/patent/create/{{row.get('Patent.id')}}" hisImage="CONTEXT_ADD"
						title="{{'fs.res.patent.priorityClaim.createOf'|hisUi:row.get('Patent.title')}}"></a> </ng-container>
			</div>
		</ng-template>
	</his-search-result>
	<br />
	
	<ng-container *ngIf="auth.hasAll('RIGHT_FS_RES_PATENT_CREATE_PATENT')">
		{{'fs.res.patent.search.notFoundQuestion'| hisUi}}<br />
		<a routerLink="/patent/create" hisImage="context_add" [queryParams]="{showSearchButton: true, showBackButton: false}">{{'fs.res.patent.priorityPatent.create'
		| hisUi }}</a> </ng-container>
</div>
